import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'gigManagement',
  initialState: {
    // Super Category
    superCategoryListLoading: false,
    superCategoryList: [],
    superCategoryPagination: {},
    updateSuperCategory: false,

    // Category
    categoryListLoading: false,
    categoryList: [],
    categoryPagination: {},
    updateCategory: false,

    // Sub Category
    subCategoryListLoading: false,
    subCategoryList: [],
    subCategoryPagination: {},
    updateSubCategory: false,

    // ================= Gig Profile (READ ONLY) =================
    gigProfileListLoading: false,
    gigProfileList: [],
    gigProfilePagination: {},
    gigProfileDetailsLoading: false,
    gigProfileDetails: null,

    gigHireList: [],
    gigHireListLoading: false,
    gigHirePagination: {},

    modalOpen: false,
    ApiError: '',
  },
  reducers: {
    // ================= Super Category (full CRUD) =================
    getSuperCategoryListApiData: (state) => {
      state.superCategoryListLoading = true
    },
    getSuperCategoryListApiSuccess: (state, { payload }) => {
      state.superCategoryListLoading = false
      state.superCategoryList = payload?.payload?.data || []
      state.superCategoryPagination = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getSuperCategoryListApiFailed: (state, { payload }) => {
      state.superCategoryListLoading = false
      state.ApiError = payload?.message
      alert(payload?.message || 'Failed to fetch super categories')
    },

    addSuperCategoryApiData: (state) => {
      state.superCategoryListLoading = true
      state.updateSuperCategory = false
      state.modalOpen = false
    },
    addSuperCategoryApiSuccess: (state, { payload }) => {
      state.updateSuperCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.superCategoryListLoading = false
      if (payload?.payload?.data) state.superCategoryList.unshift(payload.payload.data)
    },
    addSuperCategoryApiFailed: (state, { payload }) => {
      state.updateSuperCategory = false
      state.superCategoryListLoading = false
      state.ApiError = payload?.message
      alert(payload?.message || 'Failed to add super category')
    },

    updateSuperCategoryApiData: (state) => {
      state.superCategoryListLoading = true
      state.updateSuperCategory = false
    },
    updateSuperCategoryApiSuccess: (state, { payload }) => {
      state.updateSuperCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.superCategoryListLoading = false
      if (payload?.payload?.data) {
        const updated = payload.payload.data
        state.superCategoryList = state.superCategoryList.map((item) =>
          item.id === updated.id ? updated : item,
        )
      }
    },
    updateSuperCategoryApiFailed: (state, { payload }) => {
      state.updateSuperCategory = false
      state.superCategoryListLoading = false
      state.ApiError = payload?.message
      alert(payload?.message || 'Failed to update super category')
    },

    deleteSuperCategoryApiData: (state, { payload }) => {
      state.superCategoryList = state.superCategoryList.filter((item) => item.id !== payload?.id)
      state.updateSuperCategory = false
    },
    deleteSuperCategoryApiSuccess: (state, { payload }) => {
      state.updateSuperCategory = true
      state.ApiError = payload?.payload
      state.modalOpen = true
    },
    deleteSuperCategoryApiFailed: (state, { payload }) => {
      state.updateSuperCategory = false
      state.ApiError = payload?.message
      alert(payload?.message || 'Failed to delete super category')
    },

    toggleSuperCategoryStatusApiData: (state) => {
      state.superCategoryListLoading = true
      state.updateSuperCategory = false
    },
    toggleSuperCategoryStatusApiSuccess: (state, { payload }) => {
      state.superCategoryListLoading = false
      state.updateSuperCategory = true
      state.ApiError = payload?.payload
      state.modalOpen = true
      if (payload?.payload?.data) {
        const updated = payload.payload.data
        state.superCategoryList = state.superCategoryList.map((item) =>
          item.id === updated.id ? { ...item, is_active: updated.is_active } : item,
        )
      }
    },
    toggleSuperCategoryStatusApiFailed: (state, { payload }) => {
      state.superCategoryListLoading = false
      state.updateSuperCategory = false
      state.ApiError = payload?.message
      alert(payload?.message || 'Failed to toggle super category status')
    },

    // ================= Category (full CRUD) =================
    getCategoryListApiData: (state) => {
      state.categoryListLoading = true
    },
    getCategoryListApiSuccess: (state, { payload }) => {
      state.categoryListLoading = false
      state.categoryList = payload?.payload?.data || []
      state.categoryPagination = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getCategoryListApiFailed: (state, { payload }) => {
      state.categoryListLoading = false
      state.ApiError = payload?.message
      alert(payload?.message || 'Failed to fetch categories')
    },

    addCategoryApiData: (state) => {
      state.categoryListLoading = true
      state.updateCategory = false
      state.modalOpen = false
    },
    addCategoryApiSuccess: (state, { payload }) => {
      state.updateCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.categoryListLoading = false
      if (payload?.payload?.data) state.categoryList.unshift(payload.payload.data)
    },
    addCategoryApiFailed: (state, { payload }) => {
      state.updateCategory = false
      state.categoryListLoading = false
      state.ApiError = payload?.message
      alert(payload?.message || 'Failed to add category')
    },

    updateCategoryApiData: (state) => {
      state.categoryListLoading = true
      state.updateCategory = false
    },
    updateCategoryApiSuccess: (state, { payload }) => {
      state.updateCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.categoryListLoading = false
      if (payload?.payload?.data) {
        const updated = payload.payload.data
        state.categoryList = state.categoryList.map((item) =>
          item.id === updated.id ? updated : item,
        )
      }
    },
    updateCategoryApiFailed: (state, { payload }) => {
      state.updateCategory = false
      state.categoryListLoading = false
      state.ApiError = payload?.message
      alert(payload?.message || 'Failed to update category')
    },

    deleteCategoryApiData: (state, { payload }) => {
      state.categoryList = state.categoryList.filter((item) => item.id !== payload?.id)
      state.updateCategory = false
    },
    deleteCategoryApiSuccess: (state, { payload }) => {
      state.updateCategory = true
      state.ApiError = payload?.payload
      state.modalOpen = true
    },
    deleteCategoryApiFailed: (state, { payload }) => {
      state.updateCategory = false
      state.ApiError = payload?.message
      alert(payload?.message || 'Failed to delete category')
    },

    toggleCategoryStatusApiData: (state) => {
      state.categoryListLoading = true
      state.updateCategory = false
    },
    toggleCategoryStatusApiSuccess: (state, { payload }) => {
      state.categoryListLoading = false
      state.updateCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      if (payload?.payload?.data) {
        const updated = payload.payload.data
        state.categoryList = state.categoryList.map((item) =>
          item.id === updated.id ? { ...item, is_active: updated.is_active } : item,
        )
      }
    },
    toggleCategoryStatusApiFailed: (state, { payload }) => {
      state.categoryListLoading = false
      state.updateCategory = false
      state.ApiError = payload?.message
      alert(payload?.message || 'Failed to toggle category status')
    },

    // ================= Sub Category (full CRUD) =================
    getSubCategoryListApiData: (state) => {
      state.subCategoryListLoading = true
    },
    getSubCategoryListApiSuccess: (state, { payload }) => {
      state.subCategoryListLoading = false
      state.subCategoryList = payload?.payload?.data || []
      state.subCategoryPagination = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getSubCategoryListApiFailed: (state, { payload }) => {
      state.subCategoryListLoading = false
      state.ApiError = payload?.message
      alert(payload?.message || 'Failed to fetch sub categories')
    },

    addSubCategoryApiData: (state) => {
      state.subCategoryListLoading = true
      state.updateSubCategory = false
      state.modalOpen = false
    },
    addSubCategoryApiSuccess: (state, { payload }) => {
      state.updateSubCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.subCategoryListLoading = false
      if (payload?.payload?.data) state.subCategoryList.unshift(payload.payload.data)
    },
    addSubCategoryApiFailed: (state, { payload }) => {
      state.updateSubCategory = false
      state.subCategoryListLoading = false
      state.ApiError = payload?.message
      alert(payload?.message || 'Failed to add sub category')
    },

    updateSubCategoryApiData: (state) => {
      state.subCategoryListLoading = true
      state.updateSubCategory = false
    },
    updateSubCategoryApiSuccess: (state, { payload }) => {
      state.updateSubCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.subCategoryListLoading = false
      if (payload?.payload?.data) {
        const updated = payload.payload.data
        state.subCategoryList = state.subCategoryList.map((item) =>
          item.id === updated.id ? updated : item,
        )
      }
    },
    updateSubCategoryApiFailed: (state, { payload }) => {
      state.updateSubCategory = false
      state.subCategoryListLoading = false
      state.ApiError = payload?.message
      alert(payload?.message || 'Failed to update sub category')
    },

    deleteSubCategoryApiData: (state, { payload }) => {
      state.subCategoryList = state.subCategoryList.filter((item) => item.id !== payload?.id)
      state.updateSubCategory = false
    },
    deleteSubCategoryApiSuccess: (state, { payload }) => {
      state.updateSubCategory = true
      state.ApiError = payload?.payload
      state.modalOpen = true
    },
    deleteSubCategoryApiFailed: (state, { payload }) => {
      state.updateSubCategory = false
      state.ApiError = payload?.message
      alert(payload?.message || 'Failed to delete sub category')
    },

    toggleSubCategoryStatusApiData: (state) => {
      state.subCategoryListLoading = true
      state.updateSubCategory = false
    },
    toggleSubCategoryStatusApiSuccess: (state, { payload }) => {
      state.subCategoryListLoading = false
      state.updateSubCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      if (payload?.payload?.data) {
        const updated = payload.payload.data
        state.subCategoryList = state.subCategoryList.map((item) =>
          item.id === updated.id ? { ...item, is_active: updated.is_active } : item,
        )
      }
    },
    toggleSubCategoryStatusApiFailed: (state, { payload }) => {
      state.subCategoryListLoading = false
      state.updateSubCategory = false
      state.ApiError = payload?.message
      alert(payload?.message || 'Failed to toggle sub category status')
    },

    // ================= Gig Profile (READ ONLY) =================
    getGigProfileListApiData: (state) => {
      state.gigProfileListLoading = true
    },
    getGigProfileListApiSuccess: (state, { payload }) => {
      state.gigProfileListLoading = false
      state.gigProfileList = payload?.payload?.data || []
      state.gigProfilePagination = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getGigProfileListApiFailed: (state, { payload }) => {
      state.gigProfileListLoading = false
      state.ApiError = payload?.message
      alert(payload?.message || 'Failed to fetch gig profiles')
    },

    getGigProfileDetailsApiData: (state) => {
      state.gigProfileDetailsLoading = true
    },
    getGigProfileDetailsApiSuccess: (state, { payload }) => {
      state.gigProfileDetailsLoading = false
      state.gigProfileDetails = payload?.payload
    },
    getGigProfileDetailsApiFailed: (state, { payload }) => {
      state.gigProfileDetailsLoading = false
      state.ApiError = payload?.message
      alert(payload?.message || 'Failed to fetch gig profile details')
    },

    // ============== Gig Hire List (Apply List) ==============
    getGigHireListApiData: (state) => {
      state.gigHireListLoading = true
    },
    getGigHireListApiSuccess: (state, { payload }) => {
      state.gigHireListLoading = false
      state.gigHireList = payload?.payload?.data || []
      state.gigHirePagination = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getGigHireListApiFailed: (state, { payload }) => {
      state.gigHireListLoading = false
      state.ApiError = payload?.message
      alert(payload?.message || 'Failed to fetch gig hire list')
    },

    resetGigError: (state) => {
      state.ApiError = ''
      state.modalOpen = false
    },
  },
})

export const {
  // Super Category
  getSuperCategoryListApiData,
  getSuperCategoryListApiSuccess,
  getSuperCategoryListApiFailed,
  addSuperCategoryApiData,
  addSuperCategoryApiSuccess,
  addSuperCategoryApiFailed,
  updateSuperCategoryApiData,
  updateSuperCategoryApiSuccess,
  updateSuperCategoryApiFailed,
  deleteSuperCategoryApiData,
  deleteSuperCategoryApiSuccess,
  deleteSuperCategoryApiFailed,
  toggleSuperCategoryStatusApiData,
  toggleSuperCategoryStatusApiSuccess,
  toggleSuperCategoryStatusApiFailed,

  // Category
  getCategoryListApiData,
  getCategoryListApiSuccess,
  getCategoryListApiFailed,
  addCategoryApiData,
  addCategoryApiSuccess,
  addCategoryApiFailed,
  updateCategoryApiData,
  updateCategoryApiSuccess,
  updateCategoryApiFailed,
  deleteCategoryApiData,
  deleteCategoryApiSuccess,
  deleteCategoryApiFailed,
  toggleCategoryStatusApiData,
  toggleCategoryStatusApiSuccess,
  toggleCategoryStatusApiFailed,

  // Sub Category
  getSubCategoryListApiData,
  getSubCategoryListApiSuccess,
  getSubCategoryListApiFailed,
  addSubCategoryApiData,
  addSubCategoryApiSuccess,
  addSubCategoryApiFailed,
  updateSubCategoryApiData,
  updateSubCategoryApiSuccess,
  updateSubCategoryApiFailed,
  deleteSubCategoryApiData,
  deleteSubCategoryApiSuccess,
  deleteSubCategoryApiFailed,
  toggleSubCategoryStatusApiData,
  toggleSubCategoryStatusApiSuccess,
  toggleSubCategoryStatusApiFailed,

  // Gig Profile (READ ONLY)
  getGigProfileListApiData,
  getGigProfileListApiSuccess,
  getGigProfileListApiFailed,
  getGigProfileDetailsApiData,
  getGigProfileDetailsApiSuccess,
  getGigProfileDetailsApiFailed,

  // ... existing exports ...
  getGigHireListApiData,
  getGigHireListApiSuccess,
  getGigHireListApiFailed,

  resetGigError,
} = slice.actions

export default slice.reducer
